export enum StorageCollections {
  CONFIG = 'config',
  HUBCONNECT = 'hubconnect',
  SECURITY = 'security'
}
